import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from '@americanexpress/one-app-router';
import { useIntl } from 'react-intl';
import { Heading, Layout, Link } from '@americanexpress/dls-react';
import { IconChevronLeft } from '@americanexpress/dls-icons';
import style from '@americanexpress/web-react-extensions/styles/secureMessagesStyles.scss';
import { renderHTML } from '../../../../utilities/render-html';
import AnalyticsClick from '../analyticsClick';

export function BackButton(props) {
  const url = props?.url;
  const actionTagging = `back-page-arrow>>${props?.actionTag}`;
  const benefitNameTag = props?.benefitNameTag;
  // default behavior
  const reroute = () => {
    browserHistory.push(url);
  };

  const intl = useIntl(); // Hook for accessing locale content
  const buttonAriaLabel = intl.formatMessage({ id: 'shared.back-banner.button-aria-label', defaultMessage: 'Back to benefits' });

  // behavior when account key is passed in (when we need to reload the data in view-all with the correct product selected)
  // necessary for reloading enrollment status after enrollment success
  const reloadWithAccountKey = () => {
    if (global.BROWSER) {
      window.location.replace(`${url}?account_key=${props?.accountKey}`);
    }
  };

  // Navigational decision
  const btnOnClick = props?.accountKey ? reloadWithAccountKey : reroute;
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  return (
    <AnalyticsClick element={parseEntities(actionTagging)?.replace(/ /g, '-').toLowerCase()} onClick={btnOnClick} benefitNameTag={benefitNameTag?.replace(/ /g, '-').toLowerCase()}>
      <Link
        data-testid="back-button"
        isInline={true}
        href={`${url}?account_key=${props?.accountKey}`}
        aria-label={buttonAriaLabel}
      >
        <IconChevronLeft size="lg" color="black" />
      </Link>
    </AnalyticsClick>
  );
}

export function BackHeader(props) {
  const title = props?.title;
  const url = props?.url;
  const actionTag = props?.actionTag;
  const safeTitle = renderHTML(title);
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;
  const intl = useIntl(); // Hook for accessing locale content
  const headerLabel = intl.formatMessage({ id: 'shared.back-banner.header-aria-label', defaultMessage: 'Back Button and Header' });

  return (

    <Layout innerContainerClassName="no-scroll border-0">
      <header aria-label={headerLabel}>
        <div className={`${style.colorBgLightBlue} flex flex-align-center pad-2 pad-3-lg-up`}>
          <BackButton url={url} accountKey={props?.accountKey} actionTag={actionTag} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()} />
          <Heading level={1} variant="sans-medium-regular" className="flex-item-grow text-align-center">
            {safeTitle && safeTitle}
          </Heading>
        </div>
      </header>
    </Layout>
  );
}

BackHeader.propTypes = {
  // Header text
  title: PropTypes.string.isRequired,
  // Back button URL
  url: PropTypes.string.isRequired,
  // RM Action Tag
  actionTag: PropTypes.string,
  // Account key, included for enrollment success page such that view-all is refreshed with new data and not re-routed without refreshing
  accountKey: PropTypes.string,
};
